/* eslint-disable */
/* tslint:disable */
/*
 * ---------------------------------------------------------------
 * ## THIS FILE WAS GENERATED VIA SWAGGER-TYPESCRIPT-API        ##
 * ##                                                           ##
 * ## AUTHOR: acacode                                           ##
 * ## SOURCE: https://github.com/acacode/swagger-typescript-api ##
 * ---------------------------------------------------------------
 */

import type {
  DownloadCadenceRequest,
  DownloadConfigurationDto,
  DownloadConfigurationUpdateRequest,
  DownloadSettingsRequest,
  PublicKeyDto,
  SftpCredentialsRequest,
} from '../dto'
import { ContentType, HttpClient, RequestParams } from './http-client'

export class DownloadConfigurationController<SecurityDataType = unknown> {
  http: HttpClient<SecurityDataType>

  constructor(http: HttpClient<SecurityDataType>) {
    this.http = http
  }

  /**
   * No description
   *
   * @tags download-configuration-controller
   * @name GetDownloadConfiguration
   * @request GET:/api/v1/download-configurations
   */
  getDownloadConfiguration = (params: RequestParams = {}) =>
    this.http.request<DownloadConfigurationDto, any>({
      path: `/v1/download-configurations`,
      method: 'GET',
      format: 'json',
      ...params,
    })

  static getDownloadConfigurationPath = '/v1/download-configurations'
  static getDownloadConfigurationMethod = 'GET'
  /**
   * No description
   *
   * @tags download-configuration-controller
   * @name UpdateDownloadConfiguration
   * @request PUT:/api/v1/download-configurations
   */
  updateDownloadConfiguration = (
    data: DownloadConfigurationUpdateRequest,
    params: RequestParams = {},
  ) =>
    this.http.request<DownloadConfigurationDto, any>({
      path: `/v1/download-configurations`,
      method: 'PUT',
      body: data,
      type: ContentType.Json,
      format: 'json',
      ...params,
    })

  static updateDownloadConfigurationPath = '/v1/download-configurations'
  static updateDownloadConfigurationMethod = 'PUT'
  /**
   * No description
   *
   * @tags download-configuration-controller
   * @name UpdateSftpCredentials
   * @request PUT:/api/v1/download-configurations/sftp-credentials
   */
  updateSftpCredentials = (data: SftpCredentialsRequest, params: RequestParams = {}) =>
    this.http.request<DownloadConfigurationDto, any>({
      path: `/v1/download-configurations/sftp-credentials`,
      method: 'PUT',
      body: data,
      type: ContentType.Json,
      format: 'json',
      ...params,
    })

  static updateSftpCredentialsPath = '/v1/download-configurations/sftp-credentials'
  static updateSftpCredentialsMethod = 'PUT'
  /**
   * No description
   *
   * @tags download-configuration-controller
   * @name CreateSftpCredentials
   * @request POST:/api/v1/download-configurations/sftp-credentials
   */
  createSftpCredentials = (data: SftpCredentialsRequest, params: RequestParams = {}) =>
    this.http.request<DownloadConfigurationDto, any>({
      path: `/v1/download-configurations/sftp-credentials`,
      method: 'POST',
      body: data,
      type: ContentType.Json,
      format: 'json',
      ...params,
    })

  static createSftpCredentialsPath = '/v1/download-configurations/sftp-credentials'
  static createSftpCredentialsMethod = 'POST'
  /**
   * No description
   *
   * @tags download-configuration-controller
   * @name CreateDownloadSettings
   * @request POST:/api/v1/download-configurations/download-settings
   */
  createDownloadSettings = (data: DownloadSettingsRequest, params: RequestParams = {}) =>
    this.http.request<DownloadConfigurationDto, any>({
      path: `/v1/download-configurations/download-settings`,
      method: 'POST',
      body: data,
      type: ContentType.Json,
      format: 'json',
      ...params,
    })

  static createDownloadSettingsPath = '/v1/download-configurations/download-settings'
  static createDownloadSettingsMethod = 'POST'
  /**
   * No description
   *
   * @tags download-configuration-controller
   * @name CreateDownloadCadence
   * @request POST:/api/v1/download-configurations/download-cadence
   */
  createDownloadCadence = (data: DownloadCadenceRequest, params: RequestParams = {}) =>
    this.http.request<DownloadConfigurationDto, any>({
      path: `/v1/download-configurations/download-cadence`,
      method: 'POST',
      body: data,
      type: ContentType.Json,
      format: 'json',
      ...params,
    })

  static createDownloadCadencePath = '/v1/download-configurations/download-cadence'
  static createDownloadCadenceMethod = 'POST'
  /**
   * No description
   *
   * @tags download-configuration-controller
   * @name GetPublicKey
   * @request GET:/api/v1/download-configurations/public-key
   */
  getPublicKey = (params: RequestParams = {}) =>
    this.http.request<PublicKeyDto, any>({
      path: `/v1/download-configurations/public-key`,
      method: 'GET',
      format: 'json',
      ...params,
    })

  static getPublicKeyPath = '/v1/download-configurations/public-key'
  static getPublicKeyMethod = 'GET'
}
